// extracted by mini-css-extract-plugin
export var button = "_c3-2";
export var iconWrapper = "_c3-0";
export var investigatingIcon = "_c3-1";